import WarningIcon from "../../../svgs/warning.svg?react";
import Popup from "../Popup";
import { Button } from "../styledComponents";

type WarningPopupProps = {
  text: string;
  onClose: () => void;
};

const WarningPopup = ({ text, onClose }: WarningPopupProps) => (
  <Popup onClosePopup={onClose}>
    <WarningIcon className="mb-3" />
    <p className="mb-2">{text}</p>
    <Button className="mb-2 primary" onClick={onClose}>
      OK
    </Button>
  </Popup>
);

export default WarningPopup;
